import { useEffect, useRef, useState } from 'react';
import { events } from '../constants/enum';

export const useUserActivity = () => {
  const [lastActiveTime, setLastActiveTime] = useState(Date.now());

  const updateActivity = () => {
    setLastActiveTime(Date.now());
  };

  useEffect(() => {
    events.forEach((event) => window.addEventListener(event, updateActivity));
    updateActivity(); // Initialize on mount

    return () => {
      events.forEach((event) => window.removeEventListener(event, updateActivity));
    };
  }, []);

  return {
    lastActiveTime
  };
};
